"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MuiCardHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

var _MuiIconButtonRedirect = _interopRequireDefault(require("../../../MuiIconButtonRedirect/MuiIconButtonRedirect"));

var _MuiIconButtonHref = _interopRequireDefault(require("../../../MuiIconButtonHref/MuiIconButtonHref"));

var _MuiIconButtonDownload = _interopRequireDefault(require("../../../MuiIconButtonDownload/MuiIconButtonDownload"));

var _MuiIconButtonDialog = _interopRequireDefault(require("../../../MuiIconButtonDialog/MuiIconButtonDialog"));

var _GoogleConversions = _interopRequireDefault(require("../../../GoogleConversions/GoogleConversions"));

var _MuiIcon = _interopRequireDefault(require("../../../MuiIcon/MuiIcon"));

/**
 * MuiCardHeader is used in storyblok
 */
var MuiCardHeader = function MuiCardHeader(_ref) {
  var rootClass = _ref.rootClass,
      subheader = _ref.subheader,
      title = _ref.title,
      action = _ref.action,
      avatar = _ref.avatar;
  var components = {
    MuiIconButtonRedirect: _MuiIconButtonRedirect.default,
    MuiIconButtonHref: _MuiIconButtonHref.default,
    MuiIconButtonDownload: _MuiIconButtonDownload.default,
    MuiIconButtonDialog: _MuiIconButtonDialog.default,
    MuiIcon: _MuiIcon.default,
    GoogleConversions: _GoogleConversions.default
  };

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var muiavatar = avatar[0];
  var muiaction = action[0];
  return /*#__PURE__*/_react.default.createElement(_CardHeader.default, {
    className: styles.root,
    title: title,
    subheader: subheader,
    avatar: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, muiavatar ? /*#__PURE__*/(0, _react.createElement)(components[muiavatar.component], muiavatar) : null),
    action: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, muiaction ? /*#__PURE__*/(0, _react.createElement)(components[muiaction.component], muiaction) : null)
  });
};

exports.MuiCardHeader = MuiCardHeader;
var _default = MuiCardHeader;
exports.default = _default;
MuiCardHeader.propTypes = {
  /**
   * The content of the Card Title.
   */
  title: _propTypes.default.string.isRequired,

  /**
   * subheader.
  */
  subheader: _propTypes.default.string,

  /**
   * MuiIconButtonRedirect, MuiIconButtonHref, MuiIconButtonDownload, MuiIconButtonDialog, GoogleConversion
   * Allowed maximum: 1
   * The action to display in the card header.
   * */
  action: function action(props, propName, componentName) {
    var components = ['MuiIconButtonRedirect', 'MuiIconButtonHref', 'MuiIconButtonDownload', 'MuiIconButtonDialog', 'GoogleConversions'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /**
   * MuiIconButtonRedirect, MuiIconButtonHref, MuiIconButtonDownload, MuiIconButtonDialog, GoogleConversion
   * Allowed maximum: 1
   * The Avatar for the Card Header.
   * */
  avatar: function avatar(props, propName, componentName) {
    var components = ['MuiIconButtonRedirect', 'MuiIconButtonHref', 'MuiIconButtonDownload', 'MuiIconButtonDialog', 'GoogleConversion'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component. See CSS API below for more details.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string)
};
MuiCardHeader.defaultProps = {
  action: [],
  avatar: [],
  rootClass: [],
  subheader: ''
};